@if (recurringTest) {
  <app-test-recurring-form
    [test]="recurringTest"
    action="{{ 'view' | translate }}"
    (close)="closeForm()">
  </app-test-recurring-form>
}
